import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import generalReducer from "./slices/generalSlice";
import userReducer from "./slices/userSlice";
import titleReducer from "./slices/titleSlice";
import reportReducer from "./slices/reportSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";

const persistConfig = {
  version: 1,
  key: "root",
  storage, // Use localStorage for web
  whitelist: ["auth", "general", "workspace", "titleReducer", "report"],
};

const reducers = combineReducers({
  general: generalReducer,
  auth: authReducer,
  user: userReducer,
  title: titleReducer,
  report: reportReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
